module.exports = __webpack_public_path__ + "assets/media/day39.b1cbde1c.mp3";